// CSS-Dateien von Bibliotheken
import "bootstrap/dist/css/bootstrap.min.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import axios from "axios";
import App from "./App";
import "./index.css";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

if (window.__ENV__.REACT_APP_API_BASE_URL) {
  axios.defaults.baseURL = window.__ENV__.REACT_APP_API_BASE_URL;
}
axios.defaults.withCredentials = true;
axios.defaults.headers.common["X-Context"] = "admin";

root.render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
